import { Pipe } from '@angular/core';
import { KompaktdarstellungPipe } from '../kompakt-darstellung.pipe';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../services/location-strategy/component-location-strategy';
import { ArrayAbbreviatePipe } from '../../pipes/simple/array-abbreviate.pipe';
import { TranslateService } from '@ngx-translate/core';
import { FormatGebaeudeArtPipe } from '../../pipes/format/format-gebaeude-art.pipe';
import { DecimalHochkommaPipe } from '../../pipes/simple/decimalHochkomma.pipe';
import { GrundstueckListEntry } from '../../../core/gb-api';

@Pipe({
  name: 'kompaktGrundstueckbeschreibung'
})
export class KompaktGrundstueckbeschreibungPipe extends KompaktdarstellungPipe<GrundstueckListEntry> {
  constructor(
    protected formatConfigService: FormatConfigService,
    protected location: PlatformLocation,
    protected kompaktLocation: ComponentLocationStrategy,
    private abrevPipe: ArrayAbbreviatePipe,
    private translateService: TranslateService,
    private numberPipe: DecimalHochkommaPipe
  ) {
    super(formatConfigService, 'GRUNDSTUECKBESCHREIBUNG', location, kompaktLocation);
  }

  transform(entry: GrundstueckListEntry): string {
    if (this.formatElement === 'GRUNDSTUECK_BESCHREIBUNG_TYP00') {
      return this.formatTyp00(entry);
    }
    // ...
    return this.formatTyp00(entry);
  }

  private formatTyp00(entry: GrundstueckListEntry) {
    const flurname = this.abrevPipe.transform(entry.flurnamen, '...', 1, (val) => {
      return val;
    });
    const flaeche = entry.flaecheQuadratMeter ? this.numberPipe.transform(entry.flaecheQuadratMeter) + ' m²' : '';
    const gebaeudeArt = this.abrevPipe.transform(entry.gebaeudeArten, '...', 1, (a) =>
      new FormatGebaeudeArtPipe().transform(a, this.translateService)
    );
    const sonderrecht = entry.sonderrechtText || '';
    return [flurname, flaeche, gebaeudeArt, sonderrecht].filter((val) => val).join(', ');
  }
}
